import { Uchain } from "../redux/api/agent";
import { call, put, takeEvery } from 'redux-saga/effects';
import { sagaActions } from './sagaActions';
import { updateDockList, updateLastEvaluatedKey, updateLastPage, updateListLoading, updateLoading, updateLogList, updatePoIntakeList, updatePoIntakeLogPayload, updateResponseObject, updateWarehouseList, clearPoIntakeLog, updatePoIntakeVendorDockList } from "../redux/reducers/reducerSlices/PoIntakeMangementReducer";
import { showAlert } from "../App/Assests/Utility";
import { toast } from "react-toastify";


function* poIntakeDetailsSaga(data) {
  try {

    if (data.payload.CRUDTYPE && data.payload.CRUDTYPE === 'S') {
      yield put(updateListLoading(true))
    } else {
      yield put(updateLoading(true));
    }
    const response = yield call(Uchain.poIntakeMangementDetails, data.payload)

    if (data.payload.CRUDTYPE && data.payload.CRUDTYPE === 'I' && response && response.RESULT.includes('successfully')) {
      showAlert(toast.TYPE.SUCCESS, response.RESULT, 'light')
      yield put(updateResponseObject(response.RESULT))
    } else if (data.payload.CRUDTYPE && data.payload.CRUDTYPE === 'I' && response && response.RESULT.includes('ERROR')) {
      showAlert(toast.TYPE.ERROR, response.RESULT, 'light')
    }
    else if (data.payload.CRUDTYPE && data.payload.CRUDTYPE === 'U' && response && response.RESULT.includes('ERROR')) {
      showAlert(toast.TYPE.ERROR, response.RESULT, 'light')
    } else if (data.payload.CRUDTYPE && data.payload.CRUDTYPE === 'U' && response && response.RESULT.includes('successfully')) {
      showAlert(toast.TYPE.SUCCESS, response.RESULT, 'light')

      yield put(updateResponseObject(response.RESULT))
    } else if (data.payload.CRUDTYPE && data.payload.CRUDTYPE === 'D' && response && response.RESULT.includes('successfully')) {
      showAlert(toast.TYPE.SUCCESS, response.RESULT, 'light')
      yield put(updateResponseObject(response.RESULT))
    }
    else if (data.payload.CRUDTYPE && data.payload.CRUDTYPE === 'D' && response && response.RESULT.includes('ERROR')) {
      showAlert(toast.TYPE.ERROR, response.RESULT, 'light')
    }
    else if (data.payload.CRUDTYPE && data.payload.CRUDTYPE === 'S') {
      yield put(updateListLoading(true))
      yield put(updatePoIntakeList(response));
    }

  } catch (error) {
    showAlert(toast.TYPE.ERROR, error.message, 'light')
  } finally {
    yield put(updateLoading(false))
    yield put(updateListLoading(false))
  }
}

function* clearPoIntakeResponseObjectSaga() {
  yield put(updateResponseObject(''))
}

function* poIntakeLogsSaga(data) {
  try {
    if (data.payload.CRUD === 'S') {
      yield put(updateListLoading(true))

      if (!data.payload.lastEvaluatedKey) {
        yield put(updateLastPage(false))
        yield put(clearPoIntakeLog());
      }

      const response = yield call(Uchain.poIntakeMangementLogs, data.payload)

      yield put(updateLogList(response.items));
      if (response?.lastEvaluatedKey) {
        yield put(updateLastEvaluatedKey(response.lastEvaluatedKey))
      } else {
        yield put(updateLastPage(true))
      }
    }
    else {
      yield put(clearPoIntakeLog());
    }


  } catch (error) {
    showAlert(toast.TYPE.ERROR, error.message, 'light')

  } finally {
    yield put(updateLoading(false))
    yield put(updateListLoading(false))
  }
}

function* poIntakeLogPayloadStoreSaga(data) {
  try {
    yield put(updatePoIntakeLogPayload(data.payload))
  } catch (error) {

  }
}

function* poIntakeVendorDockCRUDManagementSaga(data) {
  try {
    if (data.payload.CRUDTYPE !== 'C') {   
      const response = yield call(Uchain.poIntakeVendorDockCRUDManagement, data.payload)
      yield put(updatePoIntakeVendorDockList(response))
    } else {
      yield put(updatePoIntakeVendorDockList([]))
    }
  } catch (error) {
    yield put(updatePoIntakeVendorDockList([]))
  }
}


export function* poIntakeDetailsWatcher() {
  yield takeEvery(sagaActions.GET_PO_INTAKE_MANGEMENT_DETAILS, poIntakeDetailsSaga)
}

export function* clearPoIntakeResponseObjectWatcher() {
  yield takeEvery(sagaActions.CLEAR_PO_INTAKE_RESPONSE_OBJECT, clearPoIntakeResponseObjectSaga)
}

export function* poIntakeLogWatcher() {
  yield takeEvery(sagaActions.GET_PO_INTAKE_LOGS, poIntakeLogsSaga)
}

export function* poIntakeLogPayloadStoreWatcher() {
  yield takeEvery(sagaActions.STORE_POINTAKE_LOG_PAYLOAD, poIntakeLogPayloadStoreSaga)
}

export function* poIntakeVendorDockCRUDManagementWatcher() {
  yield takeEvery(sagaActions.FETCH_POINTAKE_DOCK_VENDOR_LIST, poIntakeVendorDockCRUDManagementSaga)
}










